<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <template v-if="settings && isTimelineVisible">
            <TimelineView v-if="useNewScheduler" :url="dataUrl" :resource-pools="resourcePools" :resources="resources" :mode="mode" :shopId="shopId" :locale="locale" :component="component" :column="column" :apiKey="apiKey" :baseDomain="baseDomain" :reloadEvents="reloadEvents" :skew="false" :keepTimes="true" />
            <Timeline v-else :url="dataUrl" :resource-pools="resourcePools" :resources="resources" :mode="mode" :shopId="shopId" :locale="locale" :component="component" :column="column" :apiKey="apiKey" :baseDomain="baseDomain" :reloadEvents="reloadEvents" :skew="false" :keepTimes="true" />
          </template>
          <template v-else-if="settings">
            <h3>{{ _('No resources selected') }}</h3>
            <p>{{ _('Please select a maximum of ten resources to view in this component.') }}</p>
          </template>
        </div>
      </div>
      <div class="row" v-if="areAddButtonsVisible" style="margin-top: 10px">
        <div class="col-md-12">
          <button class="btn btn-primary" type="button" v-on:click="addResourcePoolDialog"><i class="fa fa-fw fa-sitemap"></i> {{ _('Add resource pool') }}</button>
          <button class="btn btn-primary" type="button" v-on:click="addResourceDialog"><i class="fa fa-fw fa-cube"></i> {{ _('Add resource') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import modals from '~/lib/modals'
import settingshelpers from '~/lib/settingshelpers'
import Timeline from '~/components/Timeline'
import TimelineView from '~/components/TimelineView'

export default {
  data () {
    return {
      theaters: [],
      movies: [],
      currEvent: null,
      isExisting: false,
      shouldDelete: false,
      reloadEvents: ['availabilityUpdate', 'availabilityCacheUpdate', 'componentUpdate', 'reservationUpdate'],
      allResourcePools: [],
      allResources: [],
      maxItems: 10
    }
  },
  mixins: [components, modals, settingshelpers],
  computed: {
    isTimelineVisible() {
      return (this.resources && this.resources.length) || (this.resourcePools && this.resourcePools.length)
    },
    areAddButtonsVisible () {
      // Override by Sami @11.5.2021
      return false
      /*
      if (!this.resources || !this.resourcepools) {
        return true
      }
      return this.resources.length + this.resourcepools.length < this.maxItems
      */
    },
    useNewScheduler () {
      return this.isFeatureEnabled('scheduler2.0')
    },
    dataUrl () {
      const band = this.useNewScheduler ? '&format=band' : ''
      return this.baseDomain + this.shopId + '/schedule.json?resourcepools=' + this.resourcePools.join(',') + '&resources=' + this.resources.join(',') + '&apikey=' + this.apiKey + band + (this.mode === 'hourly' ? '&hourly=true' : '')
    },
    resources () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.resources) {
          return data.resources.map(r => r.id)
        }
      }
      return []
    },
    resourcePools () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.resourcePools) {
          return data.resourcePools.map(r => r.id)
        }
      }
      return []
    },
    mode () {
      if (this.component && this.component.data) {
        const data = JSON.parse(this.component.data)
        if (data.mode) {
          return data.mode
        }
      }
      return 'daily'
    }
  },
  methods: {
    async saveComponent (data) {
      try {
        let url = this.baseDomain + this.shopId + '/components/' + data.id + '.json?apikey=' + this.apiKey
        await axios.put(url, data)
      } catch (e) {
        console.log(e)
      }
    },
    loadResources () {
      return new Promise (async (resolve) => {
        let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resources.json?version=' + this.locale + '&apikey=' + this.apiKey)
        let ret = []
        if (response && response.data) {
          for (var i = 0; i < response.data.length; i++) {
            let d = response.data[i]
            if (d.displayedtype !== 'openinghours') {
              ret.push({ id: d.id, name: d.name })
            }
          }
        }
        this.allResources = ret.sort((a, b) => a.name > b.name ? 1 : -1)
        resolve(ret)
      })
    },
    loadResourcePools () {
      return new Promise (async (resolve) => {
        let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resourcepools.json?version=' + this.locale + '&apikey=' + this.apiKey)
        let ret = []
        if (response && response.data) {
          for (var i = 0; i < response.data.length; i++) {
            let d = response.data[i]
            ret.push({ id: d.id, name: d.name })
          }
        }
        this.allResourcePools = ret.sort((a, b) => a.name > b.name ? 1 : -1)
        resolve(ret)
      })
    },
    async addResourceDialog () {
      if (!this.allResources.length) {
        await this.loadResources()
      }
      const buttons = [
        {
          title: this._('Close'),
          icon: 'close',
          handler: () => {}
        },
        {
          title: this._('OK'),
          class: 'success',
          icon: 'check',
          requiredFields: ['resource'],
          handler: (data) => {
            this.addResource(data.resource.value)
          }
        }
      ]
      this.showDialog({
        title: this._('Select a resource'),
        width: 800,
        buttons: buttons,
        fields: [
          {
            title: this._('Resource'),
            type: 'selectize',
            name: 'resource',
            options: this.allResources.map(p => { return { value: p.id, name: p.id + ': ' + p.name }}),
            defaultValue: null
          }
        ]
      })
    },
    addResource (resourceId) {
      if (!this.component) {
        return
      }
      let data
      if (!this.component.data) {
        data = { resources: [], resourcePools: [] }
      } else {
        data = JSON.parse(this.component.data)
      }
      const resource = this.allResources.find(r => r.id === resourceId)
      if (!data.resources) {
        data.resources = []
      }
      if (resource) {
        data.resources.push(resource)
      }
      this.component.data = JSON.stringify(data)
      this.saveComponent(this.component)
    },
    async addResourcePoolDialog () {
      if (!this.allResourcePools.length) {
        await this.loadResourcePools()
      }
      const buttons = [
        {
          title: this._('Close'),
          icon: 'close',
          handler: () => {}
        },
        {
          title: this._('OK'),
          class: 'success',
          icon: 'check',
          requiredFields: ['resourcepool'],
          handler: (data) => {
            this.addResourcePool(data.resourcepool.value)
          }
        }
      ]
      this.showDialog({
        title: this._('Select a resource pool'),
        width: 800,
        buttons: buttons,
        fields: [
          {
            title: this._('Resource pool'),
            type: 'selectize',
            name: 'resourcepool',
            options: this.allResourcePools.map(p => { return { value: p.id, name: p.id + ': ' + p.name }}),
            defaultValue: null
          }
        ]
      })
    },
    addResourcePool (resourcePoolId) {
      if (!this.component) {
        return
      }
      let data
      if (!this.component.data) {
        data = { resources: [], resourcePools: [] }
      } else {
        data = JSON.parse(this.component.data)
      }
      const resourcePool = this.allResourcePools.find(r => r.id === resourcePoolId)
      if (!data.resourcePools) {
        data.resourcePools = []
      }
      if (resourcePool) {
        data.resourcePools.push(resourcePool)
      }
      this.component.data = JSON.stringify(data)
      this.saveComponent(this.component)
    }
  },
  components: {
    Timeline,
    TimelineView
  }
}

</script>
